var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { novalidate: "", disabled: _vm.loadingData },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return (() => {}).apply(null, arguments)
        },
      },
    },
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "8" } },
            [
              _c(
                "v-card",
                {
                  attrs: {
                    "max-width": "1200px",
                    flat: "",
                    color: "transparent",
                  },
                },
                [
                  _c(
                    "v-card-title",
                    [
                      _c("FormHeader", {
                        attrs: {
                          loading: _vm.loading,
                          link: "page-info-pages",
                          title: _vm.getTitle
                            ? `${_vm.getTitle} статья помощи`
                            : `Создать статью помощи`,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "PageContent",
                        { attrs: { height: "90" } },
                        [
                          _c(
                            "v-container",
                            [
                              _c("InputTitleSlug", {
                                attrs: {
                                  "is-loading": _vm.loading,
                                  title: _vm.fields.name,
                                  "title-error": _vm.validationErrors.name,
                                  slug: _vm.fields.slug,
                                  "slug-error": _vm.validationErrors.slug,
                                  isSlugEnabled: !_vm.isNew,
                                },
                                on: {
                                  "change:title": function ($event) {
                                    _vm.fields.name = $event
                                  },
                                  "change:slug": function ($event) {
                                    _vm.fields.slug = $event
                                  },
                                  "input:slug": _vm.$v.fields.slug.$touch,
                                },
                              }),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "span",
                                        [
                                          _vm._v("Анонс ("),
                                          _c("TranslationIcon"),
                                          _vm._v(")"),
                                        ],
                                        1
                                      ),
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          disabled: _vm.loading,
                                        },
                                        model: {
                                          value: _vm.fields.excerpt,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.fields, "excerpt", $$v)
                                          },
                                          expression: "fields.excerpt",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "span",
                                    [
                                      _vm._v("Контент ("),
                                      _c("TranslationIcon"),
                                      _vm._v(")"),
                                    ],
                                    1
                                  ),
                                  _c("QuillEditorVue", {
                                    attrs: {
                                      cols: 12,
                                      title: "",
                                      content: _vm.fields.content,
                                      disabled: _vm.loading,
                                      loading: _vm.loading,
                                      "light-mode": "",
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.fields.content = $event
                                      },
                                      onChangeContent: function ($event) {
                                        return _vm.$emit(
                                          "change:contentForMobile",
                                          { fields: _vm.fields, $event }
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c("SeoSettings", {
                                        attrs: {
                                          data: _vm.data,
                                          loading: _vm.loading,
                                        },
                                        on: {
                                          "on-input-seo": function ($event) {
                                            _vm.fields = Object.assign(
                                              {},
                                              _vm.fields,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "mt-10", attrs: { cols: "12" } },
                                [
                                  _c("span", [
                                    _vm._v("Категории статей помощи"),
                                  ]),
                                  _vm.categories.length > 0
                                    ? _c(
                                        "v-list",
                                        _vm._l(
                                          _vm.categories,
                                          function (category) {
                                            return _c(
                                              "v-list-group",
                                              {
                                                key: category.id,
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "v-list-item-content",
                                                            [
                                                              _c(
                                                                "v-list-item-title",
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        category.name
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              _vm._l(
                                                category.children,
                                                function (child) {
                                                  return _c(
                                                    "v-list-item",
                                                    { key: child.id },
                                                    [
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "ml-3",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    child.name
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-list-item-action",
                                                        [
                                                          _vm.isNew
                                                            ? _c("v-checkbox", {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.chencgeCategory(
                                                                        child.id
                                                                      )
                                                                    },
                                                                },
                                                              })
                                                            : !!_vm.data
                                                            ? _c("v-checkbox", {
                                                                attrs: {
                                                                  "input-value":
                                                                    !!_vm.data.infoCategories.find(
                                                                      (
                                                                        category
                                                                      ) =>
                                                                        category.id ===
                                                                        child.id
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.chencgeCategory(
                                                                        child.id
                                                                      )
                                                                    },
                                                                },
                                                              })
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _vm.isNew
                ? _c("ManageSidePanel", {
                    ref: "manageSidePanel",
                    attrs: {
                      isShowSortOrder: "",
                      "is-new": _vm.isNew,
                      "is-loading": _vm.loading,
                      language: _vm.language,
                      translations: _vm.fields.translations,
                      sortOrder: _vm.fields.sortOrder,
                    },
                    on: {
                      cancel: function ($event) {
                        return _vm.$router.push({ name: "page-info-pages" })
                      },
                      submit: _vm.submit,
                      "update-translations": function ($event) {
                        return Object.assign(_vm.fields.translations, $event)
                      },
                      "language-update": function ($event) {
                        return _vm.$emit("language-update", $event)
                      },
                      "update-sort-order": function ($event) {
                        _vm.fields.sortOrder = Number($event)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "info-append",
                          fn: function () {
                            return [
                              _c("StatusPicker", {
                                attrs: {
                                  align: "center",
                                  cols: "12",
                                  title: "Статус:",
                                  disabled: _vm.loading,
                                  loading: _vm.loading,
                                  status: _vm.fields.status,
                                },
                                on: {
                                  "status:change": function ($event) {
                                    _vm.fields.status = $event
                                  },
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      987807627
                    ),
                  })
                : !!_vm.data
                ? _c("ManageSidePanel", {
                    ref: "manageSidePanel",
                    attrs: {
                      isShowSortOrder: "",
                      "is-new": !_vm.data.id,
                      "created-at": _vm.data.createdAt,
                      "updated-at": _vm.data.updatedAt,
                      "is-loading": _vm.loading,
                      language: _vm.language,
                      translations: _vm.fields.translations,
                      "entity-id": _vm.data.id,
                      "entity-type": "infoPage",
                      sortOrder: _vm.fields.sortOrder,
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.$emit("delete-info-page")
                      },
                      cancel: function ($event) {
                        return _vm.$router.push({ name: "page-info-pages" })
                      },
                      submit: _vm.submit,
                      "update-translations": function ($event) {
                        return Object.assign(_vm.fields.translations, $event)
                      },
                      "language-update": function ($event) {
                        return _vm.$emit("language-update", $event)
                      },
                      "update-sort-order": function ($event) {
                        _vm.fields.sortOrder = Number($event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "info-append",
                        fn: function () {
                          return [
                            _c("StatusPicker", {
                              attrs: {
                                align: "center",
                                cols: "12",
                                title: "Статус:",
                                disabled: _vm.loading,
                                loading: _vm.loading,
                                status: _vm.fields.status,
                              },
                              on: {
                                "status:change": function ($event) {
                                  _vm.fields.status = $event
                                },
                              },
                            }),
                            !_vm.isNew
                              ? _c(
                                  "v-row",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-col", { attrs: { cols: "6" } }, [
                                      _c("span", [
                                        _vm._v("Посмотреть на сайте"),
                                      ]),
                                    ]),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              icon: "",
                                              link: "",
                                              color: "primary",
                                              target: "_blank",
                                              href: _vm.redirerectToWebPortal,
                                              loading: _vm.loading,
                                            },
                                          },
                                          [_c("v-icon", [_vm._v("mdi-web")])],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }